import { appSettingsHubFr } from './settingsHub.fr.js';
import { appOmgevingFr } from './omgevingApp.fr.js';
import { appRecurrenceFr } from './recurrenceApp.fr.js';
import { appDomeinFr } from './domeinApp.fr.js';
import { appMemorizeFr } from './memorizeApp.fr.js';
import { appSamenFr } from './samenApp.fr.js';
import { appCareFr } from './careApp.fr.js';
import { appCultureFr } from './cultureApp.fr.js';
import { appActivitiesFr, appChecklistFr } from './golf2App.fr.js';
import { appGrowthFr, appSchoolFr } from './groeiSchoolApp.fr.js';
import { appBoardConfigFr } from './boardConfigApp.fr.js';
import { appAgendaViewsFr, appHomeFr, appWeatherDetailFr } from './homeApp.fr.js';
import { appDevicesG4Fr, appEditorG4Fr, appPrivacyRightsFr } from './golf4App.fr.js';
import { appFeedsFr, appPlacesFr, appTravelFr } from './kaartApp.fr.js';
import { appLanguagesFr } from './languagesApp.fr.js';
import { appReadAloudFr } from './readAloudApp.fr.js';
import { appModulesFr } from './modulesApp.fr.js';
import { appHouseholdsFr } from './householdsApp.fr.js';
import { appProfileFr } from './profileApp.fr.js';
import { appPushFr } from './pushApp.fr.js';
import { appRemindersFr } from './remindersApp.fr.js';
import { appTodoFr } from './todoApp.fr.js';
import { appMissedFr } from './missedApp.fr.js';
import { appBillingFr } from './billingApp.fr.js';
import { appRidesFr } from './ridesApp.fr.js';
import { appTimePickerFr } from './timePicker.fr.js';
import { appVirtualDeviceFr } from './virtualDevice.fr.js';
import { appBoardViewFr } from './boardViewApp.fr.js';
import { appDailyFr } from './dailyApp.fr.js';
import { appThemesFr } from './themesApp.fr.js';
import { appGolf6Fr } from './golf6App.fr.js';
import { appWerklijstFr } from './werklijstApp.fr.js';
import { appChildConsentFr, appPrivacyStatementFr } from './golf5App.fr.js';
// Frans (fr-FR): teksten van de ouder-webapp (zelfde vorm als app.nl.ts). Tu-vorm, korte zinnen,
// werkwoorden op knoppen. Vaste woorden: événement (afspraak), tâche, récompense, trajet (rit),
// déposer/récupérer (brengen/halen), valider (goedkeuren), tablette, associer (koppelen).
export const appFr = {
    // Golf 7 (0048): Soera's leren (memorizeApp.fr.ts).
    // Nieuwe adressen (amumin.app, board.amumin.app): bedrijfsgegevens en meldingen (domeinApp.fr.ts).
    domein: appDomeinFr,
    memorize: appMemorizeFr,
    // Golf 8 (0049): Samen wonen (samenApp.fr.ts).
    samen: appSamenFr,
    // Golf 8 (0050): dagelijkse check-in en familiekring (careApp.fr.ts).
    care: appCareFr,
    reminders: appRemindersFr,
    // 0058: to-do's zonder datum of tijd (todoApp.fr.ts).
    todo: appTodoFr,
    missed: appMissedFr,
    // 0065: aanmelden, abonnement en de banner na de proefmaand (billingApp.fr.ts).
    billing: appBillingFr,
    profile: appProfileFr,
    culture: appCultureFr,
    timePicker: appTimePickerFr,
    ridesPerDay: appRidesFr,
    modules: appModulesFr,
    // Golf 6b (0043): soorten huishouden en het beurtrooster (householdsApp.fr.ts).
    households: appHouseholdsFr,
    checklist: appChecklistFr,
    activities: appActivitiesFr,
    languages: appLanguagesFr,
    readAloud: appReadAloudFr,
    // Golf 3-integratie: groei en school (0032), kaart en agenda (0034), werklijst, virtuele iPad (0028).
    growth: appGrowthFr,
    school: appSchoolFr,
    places: appPlacesFr,
    travel: appTravelFr,
    feeds: appFeedsFr,
    werklijst: appWerklijstFr,
    virtualDevice: appVirtualDeviceFr,
    // Menu Board: het echte bord live bekijken (boardViewApp.fr.ts).
    boardView: appBoardViewFr,
    // WP4: Sterren in Taken, Ritten in Agenda, Prikbord, Kinderen, Recepten en Weekmenu (dailyApp.fr.ts).
    daily: appDailyFr,
    themes: appThemesFr,
    // Golf 6b: Vandaag als widgets, agendaweergaven en het weerdetail (homeApp.fr.ts).
    home: appHomeFr,
    // Scherm inrichten: widgets van het bord per tablet (boardConfigApp.fr.ts).
    boardConfig: appBoardConfigFr,
    agendaViews: appAgendaViewsFr,
    weatherDetail: appWeatherDetailFr,
    golf6: appGolf6Fr,
    // 0036: Jouw gegevens (golf 4).
    privacyRights: appPrivacyRightsFr,
    // Instellingen als overzicht (settingsHub.fr.ts).
    settingsHub: appSettingsHubFr,
    // Omgevingen, eigen thema, agendaverbindingen (omgevingApp.fr.ts).
    omgeving: appOmgevingFr,
    // Herhaling in gewone taal (recurrenceApp.fr.ts; packages/domain summaryLang.ts).
    recurrenceText: appRecurrenceFr,
    // Golf 5 (0044): toestemming voor een kindlogin of foto; de privacyverklaring (golf5App.fr.ts).
    childConsent: appChildConsentFr,
    privacyStatement: appPrivacyStatementFr,
    // 0038: meldingen op je telefoon (pushApp.fr.ts).
    push: appPushFr,
    nav: {
        // 0060: module Notities.
        notes: 'Notes',
        // 0064: module Fotolijst.
        photos: 'Cadre photo',
        kompas: 'Poids en forme',
        // 0069: module Geldzaken (privé).
        money: 'Finances',
        // Oprichter 6 okt: eigen to-do's in Mijn omgeving.
        myTodos: 'Mes tâches à faire',
        today: 'Aujourd’hui',
        board: 'Tableau',
        agenda: 'Agenda',
        tasks: 'Tâches',
        rewards: 'Récompenses',
        approvals: 'À valider',
        members: 'Famille',
        devices: 'Tablettes',
        settings: 'Réglages',
        security: 'Sécurité',
        household: 'Configurer le foyer',
        rides: 'Trajets',
        more: 'Plus',
        // WP2 (compact-plan): de vijf vaste plekken en de samengevoegde pagina's onder Meer.
        pinboard: 'Panneau',
        children: 'Enfants',
        together: 'Ensemble',
        boardHub: 'Tableau',
        boardView: 'Affichage',
        stars: 'Étoiles',
        membersTab: 'Membres',
        circle: 'Cercle',
        forYou: 'Pour toi',
        forYouWaiting: 'À approuver : {n}',
        menu: 'Menu',
        logout: 'Se déconnecter',
        main: 'Menu principal',
        skip: 'Aller au contenu',
        growth: 'Croissance',
        school: 'École',
        admin: 'Administration',
        werklijst: 'Liste de travail',
    },
    common: {
        save: 'Enregistrer',
        cancel: 'Annuler',
        delete: 'Supprimer',
        edit: 'Modifier',
        add: 'Ajouter',
        close: 'Fermer',
        back: 'Retour',
        next: 'Suivant',
        later: 'Plus tard',
        undo: 'Annuler l’action',
        retry: 'Réessayer',
        info: 'Explication',
        moreCount: '+{n} de plus',
        loading: 'Un instant…',
        optional: 'facultatif',
        yes: 'Oui',
        no: 'Non',
        none: 'Aucun',
        everyone: 'Tout le monde',
        minutes: { one: '{count} minute', other: '{count} minutes' },
        minutesShort: '{count} min',
        hoursMinutes: '{h} h {m} min',
        hours: { one: '{count} heure', other: '{count} heures' },
        points: { one: '{count} point', other: '{count} points' },
        by: 'par {name}',
        unknown: 'Inconnu',
        errorLoad: 'Ça n’a pas marché. Réessaie.',
        savedOk: 'Enregistré',
    },
    offline: 'Pas de connexion au serveur. Nous réessayons automatiquement.',
    today: {
        goodMorning: 'Bonjour',
        goodAfternoon: 'Bon après-midi',
        goodEvening: 'Bonsoir',
        goodNight: 'Bonne nuit',
        week: 'Semaine {week}',
        next: 'Ensuite',
        now: 'En cours',
        startsIn: 'dans {time}',
        endsIn: 'encore {time}',
        nothingNext: 'Plus rien de prévu aujourd’hui',
        nothingNextBody: 'Du temps à passer ensemble.',
        agenda: 'Agenda du jour',
        addEvent: 'Événement',
        addEventLong: 'Ajouter un événement',
        tasks: 'Tâches du jour',
        tasksAll: 'Toutes les tâches',
        noTasks: 'Pas de tâches aujourd’hui',
        approvals: 'À valider',
        approvalsWaiting: {
            one: '{count} chose t’attend',
            other: '{count} choses t’attendent',
        },
        approvalsView: 'Voir',
        ridesOpen: {
            one: '{count} trajet sans conducteur',
            other: '{count} trajets sans conducteur',
        },
        ridesAll: 'Tous les trajets',
        tomorrow: 'Demain',
        tomorrowNothing: 'Rien de prévu pour demain.',
        toAgenda: 'Voir l’agenda',
        goalsTitle: 'Tirelires',
    },
    agenda: {
        title: 'Agenda',
        prev: 'Précédent',
        next: 'Suivant',
        today: 'Aujourd’hui',
        newEvent: 'Événement',
        filter: 'Afficher pour',
        filterAll: 'Tout le monde',
        emptyDay: 'Rien de prévu ce jour-là',
        emptyDayBody: 'Touche + pour ajouter quelque chose.',
        emptyWeek: 'Rien de prévu cette semaine',
        emptyRange: 'Rien de prévu',
        weekTitle: 'Semaine {week} · {range}',
        trash: 'Corbeille',
        trashIntro: 'Les événements supprimés sont gardés 30 jours.',
        trashEmpty: 'La corbeille est vide.',
        restore: 'Restaurer',
        restoreUntil: 'Restaurable jusqu’au {date}',
        restored: '{title} est de retour dans l’agenda',
        restoreExpired: 'Cet événement a été supprimé il y a plus de 30 jours et ne peut plus revenir.',
        export: 'Exporter l’agenda',
        exportIntro: 'Télécharge l’agenda en fichier .ics pour ton téléphone ou ton ordinateur.',
        exportHousehold: 'Toute la famille',
        moved: '{title} déplacé : {when}',
        moveFailed: 'Le déplacement n’a pas marché. L’événement est revenu à sa place.',
        dragHint: 'Fais glisser un événement pour le déplacer.',
        allDay: 'Toute la journée',
        moreItems: '+{count} de plus',
    },
    event: {
        when: 'Quand',
        leave: 'Départ',
        who: 'Qui',
        where: 'Où',
        notes: 'Note',
        repeats: 'Répétition',
        rides: 'Déposer et récupérer',
        dropoff: 'Déposer',
        pickup: 'Récupérer',
        driverOpen: 'Qui conduit ?',
        driverIs: '{name} conduit',
        iDrive: 'Je conduis',
        chooseDriver: 'Choisis qui conduit',
        nobody: 'Personne pour l’instant',
        driverSaved: '{name} conduit',
        driverCleared: 'Conducteur retiré',
        depart: 'Départ {time}',
        travel: '{count} min de trajet',
        edit: 'Modifier',
        cancelOne: 'Annuler cette fois-ci',
        cancelledOne: '{title} n’a pas lieu cette fois-ci',
        cancelled: 'Annulé',
        restoreOne: 'Maintenir quand même',
        restoredOne: '{title} a lieu quand même',
        resetOne: 'Revenir à l’événement habituel',
        resetDone: 'Cette fois-ci est de nouveau comme la série',
        resetKeptRide: 'Cette fois-ci est de nouveau comme la série. Le conducteur reste celui que tu as choisi pour cette fois.',
        resetKeptReminder: 'Cette fois-ci est de nouveau comme la série. Le rappel sauté reste silencieux cette fois.',
        resetKeptBoth: 'Cette fois-ci est de nouveau comme la série. Le conducteur et le rappel sauté restent comme tu les as réglés pour cette fois.',
        moved: 'Déplacé',
        changed: 'Modifié',
        delete: 'Supprimer',
        deleted: '{title} supprimé',
        deleteTitle: 'Supprimer {title} ?',
        deleteBody: 'Tu peux le restaurer depuis la corbeille pendant 30 jours.',
        duplicate: 'Dupliquer',
        duplicated: 'Copie créée',
        history: 'Qu’est-ce qui a changé ?',
        historyEmpty: 'Aucune modification pour l’instant.',
        historyItem: '{who} · {when}',
        conflict: 'En même temps qu’autre chose',
        conflictWith: {
            one: '{names} a aussi {title} à ce moment-là',
            other: '{names} ont aussi {title} à ce moment-là',
        },
        conflictDrive: '{name} conduit à {time} mais a aussi {title} à ce moment-là',
        lastChanged: 'Modifié en dernier par {name}',
        notFound: 'Cet événement n’existe plus.',
        action: {
            create: 'créé',
            update: 'modifié',
            delete: 'supprimé',
            restore: 'restauré',
            split: 'modifié à partir d’ici',
            cancel: 'annulé',
            uncancel: 'maintenu',
            move: 'déplacé',
            override: 'adapté pour cette fois',
            override_clear: 'revenu à la série',
            role: 'conducteur modifié',
        },
    },
    editor: {
        ...appEditorG4Fr,
        newTitle: 'Nouvel événement',
        editTitle: 'Modifier l’événement',
        title: 'Quoi',
        titlePlaceholder: 'Par exemple Piscine',
        titleHint: 'Court et clair, par exemple Piscine',
        templates: 'Choix rapide',
        picto: 'Pictogramme',
        pictoChoose: 'Choisis un pictogramme',
        pictoChange: 'Autre pictogramme',
        who: 'Pour qui',
        everyone: 'Tout le monde',
        date: 'Date',
        allDay: 'Toute la journée',
        start: 'Début',
        end: 'Fin',
        duration: 'Durée',
        endDate: 'Jusqu’au',
        endBeforeStart: 'L’heure de fin est avant l’heure de début.',
        repeat: 'Répéter',
        repeatNone: 'Jamais',
        repeatDaily: 'Chaque jour',
        repeatWeekly: 'Chaque semaine',
        repeatBiweekly: 'Une semaine sur deux',
        repeatMonthly: 'Chaque mois',
        repeatYearly: 'Chaque année',
        onDays: 'Quels jours',
        monthlyHow: 'Quel jour du mois',
        monthlyDay: 'Le {day} du mois',
        monthlyLast: 'Le dernier jour',
        monthlyNth: 'Le {ordinal} {weekday}',
        ordinal: {
            '1': 'premier',
            '2': 'deuxième',
            '3': 'troisième',
            '4': 'quatrième',
            '-1': 'dernier',
        },
        parity: 'Quelles semaines',
        parityAll: 'Toutes les semaines',
        parityEven: 'Semaines paires',
        parityOdd: 'Semaines impaires',
        ends: 'Fin',
        endsNever: 'Jamais',
        endsCount: 'Après un nombre de fois',
        endsUntil: 'À une date',
        count: 'Nombre de fois',
        until: 'Jusqu’au',
        nextDates: 'Prochaines fois',
        rides: 'Déposer et récupérer',
        ridesHint: 'Qui dépose et qui récupère ? Choisis « Pas encore connu » si tu ne le sais pas encore.',
        dropoff: 'Déposer',
        pickup: 'Récupérer',
        roleNone: 'Pas besoin',
        roleOpen: 'Encore ouvert (qui conduit ?)',
        travel: 'Temps de trajet',
        travelNone: 'Aucun',
        travelOwn: 'Autre durée…',
        travelOwnLabel: 'Temps de trajet en minutes',
        /** 0056: dezelfde reistijd ook ná de afspraak. */
        travelBack: 'Trajet retour',
        travelBackHint: 'Le même temps de trajet après le rendez-vous, pour rentrer.',
        travelAuto: 'Automatique (selon le lieu)',
        travelAutoWith: 'Automatique ({minutes} min)',
        departureAlert: 'Signal de départ',
        departureAlertHint: 'Le tableau montre quand il faut partir.',
        departureNone: 'Pas de signal',
        departureBefore: '{count} min avant',
        location: 'Où',
        locationPlaceholder: 'Par exemple Piscine municipale',
        notes: 'Note',
        notesPlaceholder: 'Sac de piscine et serviette',
        category: 'Type',
        more: 'Plus d’options : déposer et récupérer, lieu, note',
        less: 'Moins d’options',
        fullScreen: 'Plein écran',
        smallScreen: 'Réduire',
        create: 'Enregistrer l’événement',
        save: 'Enregistrer',
        created: '{title} est dans l’agenda',
        saved: 'Événement enregistré',
        conflictNotice: {
            one: '{names} a aussi {title} à ce moment-là ({time}).',
            other: '{names} ont aussi {title} à ce moment-là ({time}).',
        },
        orphansTitle: 'Il y a des modifications isolées',
        orphansBody: 'Tu avais modifié certaines fois à part, et ces modifications vont disparaître. Que veux-tu en faire ?',
        orphansKeep: 'Garder comme événements séparés',
        orphansDelete: 'Supprimer',
        onlyThisNoRepeat: 'Une répétition se modifie pour cette fois et les suivantes, ou pour toute la série.',
        titleRequired: 'Indique ce que c’est.',
        memberRequired: 'Choisis pour qui c’est.',
        categories: {
            sport: 'Sport',
            school: 'École',
            medisch: 'Médecin et dentiste',
            sociaal: 'Rendez-vous',
            werk: 'Travail',
            verjaardag: 'Anniversaire',
            overig: 'Autre',
        },
    },
    scope: {
        thisHint: 'Seulement le {date}',
        followingHint: 'À partir du {date}',
        allHint: 'Toutes les fois, même avant',
        deleteFollowing: 'Supprimer celle-ci et les suivantes',
        confirm: 'Continuer',
    },
    rides: {
        title: 'Trajets',
        subtitle: 'Qui dépose et récupère qui, les 7 prochains jours.',
        open: 'Pas encore de conducteur',
        arranged: 'Réglé',
        empty: 'Tous les trajets sont réglés.',
        emptyBody: 'Personne n’a besoin de chercher quelqu’un pour l’emmener.',
        none: 'Pas de trajets cette semaine.',
        noneBody: 'Indique dans un événement qui dépose ou récupère, et le trajet apparaît ici.',
        iDrive: 'Je conduis',
        choose: 'Choisir',
        dropoff: 'Déposer',
        pickup: 'Récupérer',
        notLinked: 'Ton compte n’est pas encore lié à un membre de la famille. Choisis ci-dessous qui conduit.',
    },
    tasks: {
        title: 'Tâches',
        viewToday: 'Aujourd’hui',
        viewWeek: 'Semaine',
        viewAll: 'Toutes',
        add: 'Tâche',
        addLong: 'Ajouter une tâche',
        newTitle: 'Nouvelle tâche',
        editTitle: 'Modifier la tâche',
        library: 'Idées de tâches',
        libraryIntro: 'Choisis une tâche et pour qui. Les points sont adaptés à l’âge.',
        libraryAdd: 'Ajouter',
        libraryFor: 'Pour qui',
        what: 'Quoi',
        titlePlaceholder: 'Par exemple Mettre la table',
        who: 'Pour qui',
        mode: 'Comment',
        modeEach: 'Chacun pour soi',
        modeEachHint: 'Chacun le fait et gagne ses propres points.',
        modeTogether: 'Ensemble',
        modeTogetherHint: 'On le fait ensemble ; une seule coche pour tout le monde.',
        modeFirst: 'Le premier qui le fait',
        modeFirstHint: 'Celui qui le fait en premier gagne les points.',
        repeat: 'À quelle fréquence',
        repeatOnce: 'Une fois',
        repeatDaily: 'Chaque jour',
        repeatWeekdays: 'En semaine',
        repeatWeekly: 'Chaque semaine',
        repeatMonthly: 'Chaque mois',
        onDays: 'Quels jours',
        monthDay: 'Le jour',
        monthLast: 'Dernier jour',
        startDate: 'À partir du',
        date: 'Le',
        dueDate: 'Au plus tard',
        timeOfDay: 'Moment de la journée',
        tod: {
            any: 'Toute la journée',
            morning: 'Matin',
            afternoon: 'Après-midi',
            evening: 'Soir',
        },
        dueTime: 'Fini à',
        points: 'Points',
        pointsHint: 'Combien d’étoiles ça rapporte ? 0, c’est possible aussi.',
        approval: 'Validation nécessaire',
        approvalHint: 'Papa ou maman valide la tâche avant que les points comptent.',
        approvalHintNoPoints: 'Papa ou maman vérifie la tâche avant qu’elle compte comme faite.',
        description: 'Explication',
        create: 'Enregistrer la tâche',
        created: '{title} est prête',
        saved: 'Tâche enregistrée',
        deleteTitle: 'Supprimer {title} ?',
        deleted: '{title} supprimée',
        duplicateTitle: 'Cette tâche existe déjà',
        duplicateBody: 'Il y a déjà une tâche {title} pour {names}. En ajouter une autre quand même ?',
        addAnyway: 'Ajouter quand même',
        emptyTitle: 'Pas encore de tâches',
        emptyBody: 'Commence petit, par exemple se brosser les dents.',
        emptyToday: 'Pas de tâches aujourd’hui',
        emptyTodayBody: 'Les tâches du jour apparaissent ici.',
        progress: '{done} sur {total} finies',
        completeFor: 'Cocher pour {name}',
        completed: '{title} cochée',
        revert: 'Remettre à faire',
        reverted: '{title} est de nouveau à faire',
        skip: 'Sauter',
        skipped: '{title} sautée',
        unskip: 'Faire quand même',
        state: {
            open: 'À traiter',
            done: 'Fini',
            pending: 'En attente de validation',
            rejected: 'Encore une fois',
            skipped: 'Sautée',
            missed: 'Manquée',
        },
        late: 'Pas fini hier',
        next: 'Prochaine fois : {date}',
        noNext: 'Pas de prochaine fois',
        together: 'Ensemble',
        negativeTitle: 'Les points passent sous zéro',
        negativeBody: '{names} a déjà dépensé ces points. Le solde devient alors négatif.',
        negativeConfirm: 'Remettre quand même',
        perMember: 'Points par enfant',
    },
    rewards: {
        title: 'Récompenses',
        savings: 'Tirelires',
        available: '{count} à dépenser',
        reserved: '{count} en réserve',
        goal: 'Économise pour',
        noGoal: 'Pas encore d’objectif',
        setGoal: 'Objectif',
        goalNone: 'Pas d’objectif',
        chooseGoal: 'Choisis un objectif',
        ledger: {
            task_credit: 'Tâche',
            task_reversal: 'Tâche annulée',
            reward_debit: 'Récompense',
            reward_refund: 'Récompense remboursée',
            manual_adjustment: 'Ajusté par un parent',
            bonus: 'Bonus',
            cleaning_credit: 'Ménage',
            cleaning_reversal: 'Ménage annulé',
            // Golf 7 (0048): neutraal (blijft staan na wissen).
            learning_credit: 'Bien appris',
            learning_reversal: 'Bien appris annulé',
        },
        goalMissing: {
            one: 'Encore {count} point',
            other: 'Encore {count} points',
        },
        goalReached: 'Assez économisé',
        goalSaved: 'Objectif enregistré',
        catalogue: 'À gagner',
        add: 'Récompense',
        addLong: 'Ajouter une récompense',
        newTitle: 'Nouvelle récompense',
        editTitle: 'Modifier la récompense',
        name: 'Quoi',
        namePlaceholder: 'Par exemple Aller manger une glace ensemble',
        cost: 'Combien d’étoiles ?',
        costHint: 'Le prix de la récompense en étoiles (1 à 9999).',
        costInvalid: 'Choisis un nombre de 1 à 9999.',
        forWhom: 'Pour qui',
        forAll: 'Tous ceux qui ont des points',
        limit: 'À quelle fréquence',
        limitNone: 'Autant que tu veux',
        limitDay: '{count}× par jour',
        limitWeek: '{count}× par semaine',
        limitMonth: '{count}× par mois',
        stock: 'Stock',
        stockNone: 'Illimité',
        stockLeft: 'Encore {count} en stock',
        created: '{name} ajouté',
        saved: 'Récompense enregistrée',
        archive: 'Retirer',
        archiveTitle: 'Retirer {name} ?',
        archiveBody: 'Les enfants ne la verront plus. Les demandes précédentes restent enregistrées.',
        archived: '{name} retiré',
        requests: 'Demandes',
        requestsEmpty: 'Aucune demande en attente.',
        give: 'Donner',
        given: '{name} donné à {member}',
        decline: 'Refuser',
        declined: 'Demande refusée ; les points sont rendus',
        adjust: 'Ajuster les points',
        adjustTitle: 'Ajuster les points de {name}',
        adjustAmount: 'Combien',
        adjustAmountHint: 'Mets un moins pour retirer, par exemple -5.',
        adjustReason: 'Pourquoi',
        adjustReasonPlaceholder: 'Par exemple Aide en plus au jardin',
        adjustInvalid: 'Choisis un nombre entre -999 et 999 (pas 0).',
        adjustReasonRequired: 'Écris en quelques mots pourquoi.',
        adjusted: 'Le solde de {name} est maintenant de {count}',
        negativeTitle: 'Le solde devient négatif',
        negativeBody: '{name} passe ainsi sous zéro. Tu confirmes ?',
        negativeConfirm: 'Oui, ajuster',
        history: 'Derniers points',
        historyEmpty: 'Pas encore de points gagnés.',
        pointsOff: 'Les points sont désactivés',
        export: 'Exporter (CSV)',
    },
    approvals: {
        title: 'À valider',
        open: 'À traiter',
        handled: 'Traité',
        approve: 'Valider',
        approved: '{title} validé',
        reject: 'Refuser',
        rejectTitle: 'Refuser {title} ?',
        rejectNote: 'Qu’est-ce qu’il reste à faire ?',
        rejectNotePlaceholder: 'Par exemple Les assiettes ne sont pas encore sur la table',
        rejected: '{title} retourne à {name}',
        asks: '{name} demande',
        doneAt: 'fini à {time}',
        doneAgo: 'fini {ago}',
        give: 'Donner',
        decline: 'Refuser',
        notices: 'Bon à savoir',
        emptyTitle: 'Tout est traité',
        emptyBody: 'Rien à valider.',
        handledEmpty: 'Ce que tu as traité s’affichera ici.',
        state: {
            fulfilled: 'Donné',
            declined: 'Refusé',
            cancelled: 'Retiré',
            expired: 'Expiré',
            pending: 'En attente',
        },
        together: 'avec {names}',
    },
    members: {
        title: 'Famille',
        intro: 'Tous ceux qui figurent sur le tableau. Leur couleur et leur visage sont repris partout.',
        add: 'Membre',
        addLong: 'Ajouter un membre',
        newTitle: 'Nouveau membre',
        editTitle: 'Modifier {name}',
        // Volgorde van het gezin (2026-10-01).
        orderHint: 'Les flèches fixent l’ordre. Il s’applique partout : dans l’app et sur le tableau.',
        moveUp: 'Avancer {name}',
        moveDown: 'Reculer {name}',
        orderNow: '{name} est maintenant à la place {position} sur {count}.',
        orderStale: 'Quelque chose a changé dans la famille entre-temps. La liste a été rechargée.',
        name: 'Prénom',
        namePlaceholder: 'Par exemple Léa',
        // 0057 (oprichter 1 okt): initialen achter de afspraak.
        initials: 'Initiales',
        initialsHint: 'Une à trois lettres. Elles apparaissent après le rendez-vous dans l’agenda, par exemple Football · A.',
        initialsInvalid: 'Saisis une à trois lettres.',
        kind: 'Qui est-ce',
        kindAdult: 'Parent',
        kindChild: 'Enfant',
        kindHelper: 'Baby-sitter ou aide',
        age: 'Âge',
        ageNone: 'Je ne sais pas',
        ageBands: {
            '0-5': 'moins de 6 ans',
            '6-9': '6–9 ans',
            '10-12': '10–12 ans',
            '13-15': '13–15 ans',
            '16+': '16 ans ou plus',
        },
        face: 'Visage',
        faceNone: 'Première lettre',
        preview: 'Aperçu',
        saved: '{name} enregistré',
        created: '{name} fait maintenant partie de la famille',
        you: 'Toi',
        points: 'Gagne des points',
        inviteTitle: 'Invite ton ou ta partenaire',
        inviteBody: 'Planifier ensemble, c’est plus simple. Ajoute ton ou ta partenaire, puis invite-le par e-mail.',
    },
    devices: {
        ...appDevicesG4Fr,
        title: 'Tablettes',
        intro: 'Les tablettes qui affichent le tableau familial.',
        add: 'Associer une tablette',
        online: 'En ligne',
        seen: 'Vue {ago}',
        never: 'Jamais vue',
        version: 'Version {version}',
        room: 'Pièce',
        rename: 'Renommer',
        renameTitle: 'Renommer la tablette',
        revoke: 'Dissocier',
        revokeTitle: 'Dissocier cette tablette ?',
        revokeBody: '{name} affichera de nouveau un code d’association. Tu pourras l’associer à nouveau plus tard.',
        revoked: '{name} dissociée',
        saved: 'Tablette enregistrée',
        statusRevoked: 'Dissociée',
        statusSuspect: 'À vérifier',
        emptyTitle: 'Associe la tablette',
        emptyBody: 'Ouvre le tableau familial sur la tablette et saisis le code ici.',
    },
    settings: {
        title: 'Réglages',
        household: 'Foyer',
        householdName: 'Nom',
        timezone: 'Fuseau horaire',
        wizard: 'Configurer le foyer',
        security: 'Sécurité',
        securityBody: 'Réseaux, navigateurs et sessions de confiance.',
        export: 'Exporter l’agenda',
        exportBody: 'Télécharge l’agenda en fichier .ics, pour toute la famille ou par personne.',
        exportAll: 'Toute la famille',
        data: 'Télécharger les données',
        dataBody: 'Une copie des données de ta famille en fichier (JSON), y compris les choix de « Ce qui convient à notre famille ». Tu confirmes d’abord avec ton mot de passe.',
        dataMine: 'Mes données',
        dataAll: 'Toute la famille',
        dataStarted: 'Le fichier est dans tes téléchargements.',
        about: 'À propos',
        version: 'Version {version}',
        open: 'Ouvrir',
    },
    wizard: {
        step: 'Étape {n} sur {total}',
        step1Title: 'Bienvenue à la maison',
        step1Body: 'Voir la semaine ensemble, sans prise de tête. On commence par ta famille.',
        householdName: 'Nom de ton foyer',
        householdPlaceholder: 'Famille Martin',
        yourName: 'Ton nom sur le tableau',
        yourNameHint: 'Par exemple Papa ou Julie',
        step2Title: 'Qui en fait partie ?',
        step2Body: 'Donne une couleur à chacun. Un enfant peut aussi choisir un animal.',
        addMember: 'Ajouter quelqu’un',
        memberAdded: '{name} ajouté',
        step3Title: 'Premières tâches',
        step3Body: 'Coche quelques petites tâches régulières. Tu pourras tout modifier plus tard.',
        step3For: 'Pour les enfants',
        step3Added: {
            one: '{count} tâche ajoutée',
            other: '{count} tâches ajoutées',
        },
        step3NoKids: 'Ajoute d’abord un enfant pour lui donner des tâches.',
        step4Title: 'Associe la tablette',
        step4Body: 'Ouvre le tableau familial sur la tablette du salon et saisis le code.',
        pairNow: 'Associer la tablette',
        finish: 'Terminer',
        done: 'Ton foyer est prêt',
    },
    notFoundTitle: 'Cette page n’existe pas',
    notFoundBody: 'Le lien est peut-être ancien. Retourne à Aujourd’hui.',
    toToday: 'Aller à Aujourd’hui',
    crashTitle: 'Oups, ça n’a pas marché',
    crashBody: 'Réessaie. Ça ne marche toujours pas ? Recharge la page.',
    reload: 'Recharger',
};
//# sourceMappingURL=app.fr.js.map